import * as Colors from '@brightlayer-ui/colors';
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GetOrganizationsForAdmin } from '../../../server/client/ableEdge/types';
import { ErrorState } from '../../components/ErrorState';
import { PageWrapper } from '../../components/PageWrapper';
import { Spinner } from '../../components/Spinner';
import { OrganizationService } from '../../services/organization/organization.service';
import { AdminDashboardTable } from './AdminDashboardTable';

const styles = {
    listBox: {
        margin: '25px',
        backgroundColor: Colors.white[50],
        borderRadius: '2px',
    },
    emptyState: {
        alignContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    divider: {
        borderBottomWidth: '2px',
    },
    informationBlock: {
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    dashboardTable: {
        padding: '0 24px 24px',
    },
};

export const AdminDashboardPage: React.FC = () => {
    const { t } = useTranslation();
    const [error, setError] = useState(false);
    const [organizationRequests, setOrganizationRequests] = useState<GetOrganizationsForAdmin[]>();

    const [refreshKey, setRefreshKey] = useState(0);

    const fetchUserDetails = async (): Promise<void> => {
        try {
            const result = await OrganizationService.getOrganizationsForAdmin();
            if (result) {
                setOrganizationRequests(result);
            }
        } catch {
            setError(true);
        }
    };

    useEffect(() => {
        void fetchUserDetails();
    }, [refreshKey]);

    const handleRefresh = (): void => {
        setRefreshKey((k) => k + 1);
    };

    return (
        <PageWrapper title={t('DRAWER.ORGANIZATION_REQUESTS')}>
            {error ? (
                <ErrorState />
            ) : !organizationRequests ? (
                <Spinner />
            ) : (
                <Box sx={styles.listBox}>
                    <Box sx={styles.informationBlock}>
                        <Typography data-testid="admin-dashboard-header" variant="h6">
                            {t('ADMIN_DASHBOARD.LIST_REQUESTS')}
                        </Typography>
                        <Typography variant="subtitle2" color={Colors.gray[500]}>
                            {t('ADMIN_DASHBOARD.LIST_REQUESTS_INFORMATION')}
                        </Typography>
                    </Box>
                    <Box sx={styles.dashboardTable}>
                        <AdminDashboardTable tableData={organizationRequests} onRefresh={handleRefresh} />
                    </Box>
                </Box>
            )}
        </PageWrapper>
    );
};
